import { Space, Divider } from 'antd';
import { DragHandle } from "components/UIBuilder/Global/SortableHelper";
import CustomButton from 'components/UIBuilder/CustomComponent/CustomButton'
import { compareUIElementValue } from 'util/Compare';
import * as globalFunction from 'util/GlobalFunction';
import { config } from "util/config";

//根据数据设置表头和Action列
export function setTableColumns({ props, sort, sectionComponent, pageComponent }) {
  let columns = [];
  //判断是否要排序
  if (sort) {
    columns.push({
      title: '',
      dataIndex: 'Sort',
      fixed: config.component.Table.fixed,
      className: 'drag-visible',
      render: () => <DragHandle />,
    })
  }

  //设置Action列的按钮
  if ((pageComponent.state.jobData === undefined || globalFunction.isNullOrEmpty(pageComponent.state.jobData.LockReason) || !sectionComponent.props.section.enableLock) && props.viewConfig.rowButtonList.length > 0) {
    columns.push({
      title: '',
      dataIndex: 'action',
      key: 'action',
      fixed: config.component.Table.fixed,
      className: 'ActionColumn',
      render: (_, record) => <Space size={[0, 0]} split={<Divider type="vertical" className='button-divider' />} >
        {
          props.viewConfig.rowButtonList.map((rowButton, i) =>
            rowButton.buttonList.map((button, j) => <CustomButton button={button} section={props.section} sectionComponent={sectionComponent} pageComponent={pageComponent} parameter={record} />))
        }
      </Space>,
    });
  }
  //设置自定义的列
  props.viewConfig.groupList[0].uieList.map((uie, i) => {
    columns.push({
      title: uie.title,
      dataIndex: uie.source,
      key: uie.source,
      width: uie.width != '' ? uie.width : null,
      fixed: uie.fixedDirection != null ? uie.fixedDirection : config.component.Table.fixed,
      align: uie.align != null ? uie.align : null,
      sorter: uie.sort ? (a, b) => compareUIElementValue(a[uie.source], b[uie.source], uie.type) : null,
      render: (data, record) => globalFunction.formatUieData({ uie: uie, data: data, record: record, companyId: props.companyId, sectionComponent: sectionComponent, pageComponent: pageComponent }),
    });
  });
  return columns;
}

